<template>
  <basicContainer>
    <div class="announcementManage">
      <el-row :gutter="100">
        <el-col :span="12">
          <el-row class="grxx">
            <el-col :span="3" class="fontw">
              <div><span>姓名：</span></div>
            </el-col>
            <el-col :span="21">
              <div>
                <el-input v-model="xm" disabled></el-input>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row class="grxx">
            <el-col :span="3" class="fontw">
              <div><span>工号：</span></div>
            </el-col>
            <el-col :span="21">
              <div>
                <el-input v-model="gh" disabled></el-input>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="mt30">
        <template>
          <el-table v-loading="isLoading" element-loading-background="rgba(255, 255, 255, .5)"
            element-loading-text="加载中，请稍后..." element-loading-spinner="el-icon-loading" :data="tableData" border
            style="width: 100%" class="el-table--small">
            <el-table-column type="index" label="序号" :index="indexMethod" width="60" align="center"></el-table-column>
            <el-table-column prop="rwmc" label="主任务" width="150" :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="zrw" label="子任务" width="150" :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="srw" label="孙任务" width="150" :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="wczt" label="完成状态" width="80"></el-table-column>
            <el-table-column prop="zp" label="自评" width="80"></el-table-column>
            <el-table-column prop="jgpj" label="结果评价(70%)" width="140"></el-table-column>
            <el-table-column prop="gcpj" label="过程评价(30%)" width="140"></el-table-column>
            <el-table-column prop="zf" label="总分" width="60"></el-table-column>
            <el-table-column prop="ld" label="亮点" :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="dgj" label="待改进" :show-overflow-tooltip='true'></el-table-column>
            <el-table-column prop="bz" label="备注" :show-overflow-tooltip='true'></el-table-column>
          </el-table>
        </template>
      </div>
      <el-row class="smallTitle grxx">
        <el-col :span="2" class="tl fontw">汇总得分：</el-col>
        <el-col :span="3" class="tl"><el-input v-model="hzdf" disabled class="disabledfont"></el-input></el-col>
      </el-row>
      <el-row class="smallTitle">
        <el-col :span="2" class="tl fontw">备&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;注：</el-col>
        <el-col :span="22" class="tl"><el-input type="textarea" :rows="5" v-model="bz" readonly></el-input></el-col>
      </el-row>

    </div>
  </basicContainer>
</template>

<script>
import crudPageMinix from '@/businessManagement/utils/crudPageMinix.js'
export default {
  components: {},
  props: ['khxqConfig'],
  mixins: [crudPageMinix],
  data() {
    return {
      xm: this.khxqConfig.xm,
      gh: this.khxqConfig.gh,
      hzdf: '暂未评分',
      bz: '暂未备注',
      form: {},
      tableData: []
    }
  },

  mounted() {
    this.loadData()
    this.initData()
  },
  methods: {
    loadData() {
      this.$http
        .post('/performance/getCEOZSXQNew', null, {
          params: {
            pageNum: 1, // 当前页
            pageSize: 999, // 每页多少条
            loginName: this.khxqConfig.gh,
            Monthy: this.khxqConfig.yf
          }
        }).then(res => {
          this.tableData = res.data.records
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
    },
    initData() {
      this.$http
        .post('/performance/queryDetailsGradeNew', null, {
          params: {
            loginName: this.khxqConfig.gh,
            Monthy: this.khxqConfig.yf
          }
        }).then(res => {
          if (res.data.length > 0 && res.data[0].ZGPFHZ) {
            this.hzdf = res.data[0].ZGPFHZ || ''
            this.bz = res.data[0].BZ || ''
          }
          // this.tableData = res.data.records
        }).catch(error => {
          this.$message.error(error.msg || error.message)
        })
    },
    view(row) {
      this.$router.push({
        path: '/applyForm',
        query: {
          businessKey: row.id,
          processInstanceId: row.procid,
          //   taskId: null,
          //   formId: null,
          pageKey: 'VIEW'
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.prestyle {
  font-family: Chinese Quote, -apple-system, BlinkMacSystemFont, Segoe UI,
    PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica,
    Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  margin: 0;
}
.rwms {
  border: 1px #dcdfe6 solid;
  border-radius: 5px;
  padding: 0 15px;
  max-height: 500px;
  overflow-y: scroll;
  line-height: 2;
}
.rwmscon {
  line-height: 2.5rem;
}
:deep(.no-border .el-input__inner) {
  border: none !important;
}
:deep(.el-table th > .cell) {
  color: rgba(0, 0, 0, 0.85) !important;
}
.announcementManage {
  padding: 0 20px 30px;
}
:deep(.disabledfont .el-input__inner) {
  color: red !important;
}
.fontw {
  font-size: 14px;
}
.grxx {
  display: flex;
  align-items: center;
}
.borderLeft::before {
  content: "";
  display: inline-block;
  width: 5px;
  height: 12px;
  background-color: #5a9bf5;
  margin-right: 5px;
}
.smallTitle {
  line-height: 1;
  margin-top: 30px;
}
.redFont {
  color: #ff1010;
}
.tr {
  text-align: right;
}
.mt30 {
  margin-top: 30px;
}
.mt15 {
  margin-top: 15px;
}
.pt10 {
  padding-top: 10px;
}
:deep(.theme-longyun .avue-contail, .theme-longyun .avue-main) {
  background-color: white !important;
}

.table-expand {
  font-size: 0;
}
:deep(.table-expand label) {
  width: 110px;
  color: #99a9bf !important;
  font-size: 12px;
}
:deep(.table-expand .el-form-item) {
  margin-right: 0;
  margin-bottom: 0;
  width: 100%;
}
:deep(.table-expand .el-form-item__content) {
  font-size: 12px !important;
}
</style>
